<template>
  <div class="address-container">
    <div class="header-container">
      {{ title }}
      <button
        type="button"
        class="edit-btn"
        @click="edit"
      >
        Edit
      </button>
    </div>
    <div class="address-body">
      <div>
        {{ address.address1 }}
      </div>
      <div
        v-if="address.address2"
      >
        {{ address.address2 }}
      </div>
      <div>
        {{ address.city }},
        {{ address.state }}
        {{ address.zip }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderAddress',
  props: {
    title: String,
    address: Object,
    edit: Function,
  },
};
</script>

<style lang="scss" scoped>
.address-container {
  border: 2px solid $N5;
  border-radius: 6px;
  .header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: $N5;
    border-radius: 6px;
    color: $N90;
    padding: 8px 10px;

    .edit-btn {
      background-color: $N50;
      padding: 0 8px;
      color: $WHITE;
      font-size: 0.75rem;
      border-radius: 4px;
    }
  }
  .address-body {
    padding: 4px 10px;
  }
}
</style>
